import axios from "axios";
import { getRegistrationInfoFail, 
	getRegistrationInfoStart, 
	getRegistrationInfoSuccess, 
	registrationFail, 
	registrationStart, 
	registrationSuccess } from "./RegistrationActions";

import { apiUrl } from "../../config";

export const getRegistrationInfo = async (userId, token, dispatch) => {
	dispatch(getRegistrationInfoStart());

	try {
		const res = await axios.get(apiUrl + "/user/register/" + userId + "/" + token);
		dispatch(getRegistrationInfoSuccess(res.data))
	} catch (error) {
		dispatch(getRegistrationInfoFail());
	}
};

export const register = async (userId, registrationModel, dispatch) => {
	dispatch(registrationStart());	

	try {
		await axios.post(apiUrl + "/user/register/" + userId, registrationModel);
		dispatch(registrationSuccess())
	} catch (error) {
		dispatch(registrationFail(error.response?.data || error.message));
	}
}